import { useTranslation } from 'react-i18next'
import { M_Fieldset } from 'src/M_Components'
import { ShipmentFormField } from './ShipmentFormField'

const flashPtUnitOptions = [
    { label: 'Celsius (°C)', value: 'C' },
    { label: 'Fahrenheit (°F)', value: 'F' },
    { label: 'Other', value: 'O' },
]

export const ShipmentDangerousGoods = ({ dataState, setDataState }) => {
    const { t } = useTranslation()

    const onDangerousGoodsSelect = (_data, _fields, obj) => {
        if (!obj) {
            setDataState(prev => ({
                ...prev,
                IdDangerousGoods: null,
                DangerousGoodsCode: '',
                DangerousGoodsName: '',
                DangerousGoodsDescription: '',
            }))
            return
        }
        setDataState(prev => ({
            ...prev,
            IdDangerousGoods: obj.Id || null,
            DangerousGoodsCode: obj.Code || '',
            DangerousGoodsName: obj.Name || '',
            DangerousGoodsDescription: obj.Description || '',
        }))
    }

    return (
        <M_Fieldset
            labelInside
            label={
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '20px', marginLeft: '10px' }}>
                    <i className='pi pi-exclamation-triangle' style={{ fontSize: '18px' }} />
                    {t('DangerousGoods')}
                </div>
            }
            elements={
                <div style={{ display: 'flex', flexDirection: 'column', padding: '10px' }}>
                    <div style={{ display: 'flex', alignItems: 'flex-end', flexWrap: 'wrap' }}>
                        <ShipmentFormField
                            fields={{
                                display: t('UNNo'),
                                code: 'DangerousGoodsCode',
                                type: 'foreignKey',
                                entity: 'DangerousGoods',
                                tableLabel: t('DangerousGoods'),
                                filterField: 'Code',
                                labelFields: ['Code'],
                                fields: [
                                    { key: 'Code', value: 'DangerousGoodsCode' },
                                    { key: 'Name', value: 'DangerousGoodsName' },
                                    { key: 'Description', value: 'DangerousGoodsDescription' },
                                    { key: 'Id', value: 'IdDangerousGoods' },
                                ],
                            }}
                            index={50}
                            data={dataState}
                            setData={setDataState}
                            returnFunc={onDangerousGoodsSelect}
                        />
                        <ShipmentFormField
                            fields={{ display: t('PSN'), code: 'DangerousGoodsName', type: 'disabled', grow: true }}
                            index={51}
                            data={dataState}
                            setData={setDataState}
                        />
                        <ShipmentFormField
                            fields={{ display: t('EmS'), code: 'DangerousGoodsDescription', type: 'disabled', size: '180px' }}
                            index={52}
                            data={dataState}
                            setData={setDataState}
                        />
                    </div>

                    <div style={{ display: 'flex', alignItems: 'flex-end', flexWrap: 'wrap' }}>
                        <ShipmentFormField
                            fields={{ display: t('MarineDescription1'), code: 'MarineDescription', type: 'text', grow: true }}
                            index={53}
                            data={dataState}
                            setData={setDataState}
                        />
                    </div>

                    <div style={{ display: 'flex', alignItems: 'flex-end', flexWrap: 'wrap' }}>
                        <ShipmentFormField
                            fields={{ display: t('FlashPt'), code: 'FlashPT', type: 'number', size: '120px' }}
                            index={54}
                            data={dataState}
                            setData={setDataState}
                        />
                        <ShipmentFormField
                            fields={{ display: t('FlashPointUnit'), code: 'FlashPTUnit', type: 'select', options: flashPtUnitOptions, size: '180px' }}
                            index={55}
                            data={dataState}
                            setData={setDataState}
                            options={flashPtUnitOptions}
                        />
                        <ShipmentFormField
                            fields={{ display: 'M/P', code: 'MP', type: 'checkbox', size: '120px' }}
                            index={56}
                            data={dataState}
                            setData={setDataState}
                        />
                        <ShipmentFormField
                            fields={{ display: t('PackingGroup'), code: 'PackingGroup', type: 'text', size: '160px' }}
                            index={57}
                            data={dataState}
                            setData={setDataState}
                        />
                        <ShipmentFormField
                            fields={{ display: t('LimitedQuantities'), code: 'ShipmentLimitedQuantities', type: 'checkbox', size: '180px' }}
                            index={58}
                            data={dataState}
                            setData={setDataState}
                        />
                        <ShipmentFormField
                            fields={{ display: t('MarineWeight'), code: 'MarineWeight', type: 'number', size: '150px' }}
                            index={59}
                            data={dataState}
                            setData={setDataState}
                        />
                        <ShipmentFormField
                            fields={{ display: t('ApprovalNumber'), code: 'ApprovalNumber', type: 'text', size: '200px' }}
                            index={60}
                            data={dataState}
                            setData={setDataState}
                        />
                    </div>
                </div>
            }
        />
    )
}
